
export const LOCAL_PHOTO_API_IP = process.env.REACT_APP_STATIC_URL
export const BASE_URL = process.env.REACT_APP_API_URL

if (!BASE_URL) {
  console.warn('REACT_APP_API_URL not set, using default')
}

export const HOMEPAGE_ROUTE = '/'
export const ADMIN_ROUTE = '/admin'
export const AUTH_ROUTE = '/auth'
export const CALCULATOR_ROUTE = '/calculator'
export const PLAIN_ROTE = '/plain'
export const MULTICOLORS_ROUTE = '/mixed'
export const PRODUCT_ROUTE = '/product'
export const MIXED_PRODUCT_ROUTE = '/mixed-product'
export const UPDATE_BRICK = '/update-brick'
export const NOT_FOUND = '/404'
